<template>

    <div class="behavior-report-step-2">

        <p>
            Select your rating items, and a response format for each item
        </p>

        <div class="alert alert-warning"
             v-if="!docData.ratingItems || !docData.ratingItems.length">
            No rating items selected - click below to add a rating item.
        </div>

        <b-btn variant="primary" size="lg" 
               @click="openAddRatingItemModal()">
            <open-icon name="plus"></open-icon>
            Add Rating Item...
        </b-btn>

        <p>
        </p>

        <draggable class="dragArea"
                   v-model="docData.ratingItems">
            <b-card no-body class="drag mb-1"
                    v-for="item in docData.ratingItems" :key="item.key">
                <b-card-body class="pt-3 pb-1">
                    <b-row class="drag text-center">
                        <b-col cols="1">
                            <open-icon name="resize-height"></open-icon>
                        </b-col>
                        <b-col cols="9">
                            <b-form-textarea v-model="item.statement"></b-form-textarea>

                            <b-form class="mt-3">
                                <b-form-group label="Response Format"
                                              label-cols="auto">
                                    <b-form-select v-model="item.responseFormat"
                                                   :options="responseFormatOptions">
                                    </b-form-select>
                                </b-form-group>
                            </b-form>
                        </b-col>
                        <b-col cols="2">
                            <b-btn variant="default" size="sm"
                                   @click="deleteRatingItem(item)">
                                <open-icon name="delete"></open-icon>
                            </b-btn>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </draggable>

        <!-- add rating item modal -->

        <b-modal id="add-rating-item-modal"
                 title="Add a Rating Item">

            <b-btn variant="primary" class="float-right"
                   @click="addRatingItem('Custom...')">
                <open-icon name="plus"></open-icon>
                Add Custom Item
            </b-btn>

            <div style="clear:both; padding: 5px"></div>

            <div v-for="(group, index) in config.behaviorReport.statementGroups">
                <b-card no-body>
                    <b-card-header v-b-toggle="`group_${index}`">
                        <open-icon name="chevron-bottom" v-if="group.visible"></open-icon>
                        <open-icon name="chevron-right" v-if="!group.visible"></open-icon>
                        {{ group.title }}
                    </b-card-header>
                    <b-collapse :id="`group_${index}`"
                                v-model="group.visible">
                        <b-card-body>
                            <b-btn variant="success" class="select-statement-button"
                                   v-for="statement in group.statements"
                                   @click="addRatingItem(statement.text)">
                                {{ statement.text }}
                            </b-btn>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>

        </b-modal>
    </div>

</template>

<script>

    import Vue from 'vue'
    import draggable from 'vuedraggable'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "BehaviorReportStep2",
        mixins: [ToolMixin],
        components: {
            draggable,
        },
        data() {
            const responseFormatOptions = _.map(
                _.filter(this.$store.state.config.behaviorReport.responseFormats, (f) => f.enabled),
                (format) => {
                    return {value: format.title, text: format.title}
                }
            )

            return {
                responseFormatOptions: responseFormatOptions
            }
        },
        methods: {
            openAddRatingItemModal() {
                this.$bvModal.show('add-rating-item-modal')
            },
            addRatingItem(statement) {
                // NB: must update ratingItems thus in order for the docData watcher to fire when the array
                // is initially empty! (see App::watch)
                Vue.set(this.docData, 'ratingItems', _.concat(
                    this.docData.ratingItems ? this.docData.ratingItems : [],
                    [{statement: statement}]
                ))
                this.$bvModal.hide('add-rating-item-modal')
            },
            deleteRatingItem(item) {
                this.docData.ratingItems = _.without(this.docData.ratingItems, item)
            },
            formatTitle(title) {
                return title
            }
        }
    })

</script>

<style lang="scss">

    .behavior-report-step-2 {

    }

    .select-statement-button {
        white-space: normal;
        text-align: left;
        margin-bottom: 10px;
    }
</style>
